import { fetch } from '@mindbaz/app-manager';

const getCustomDashboards = async (idCompany: number) => {
  return fetch({
    method: 'GET',
    url: `${import.meta.env.VITE_API_CORE}customdashboards/${idCompany}`,
  }).then((result: any) => {
    return result.data.data;
  });
};

export default getCustomDashboards;
